import React from 'react'

const Panel = (props) => {
  const [state, setState] = React.useState({
    displayName: 'Tabs',
  })
  return (
    <div>
      {props.children}
    </div>
  );

}

export default Panel;



// WEBPACK FOOTER //
// ./src/components/common/Tabs/Panel.js